import {
  CHANGE_HEADER_VISIBLE,
} from './actions'

export default function(state = {
  visible: {
    status: false,
    type: ''
  }
}, action) {
  switch(action.type) {
    case CHANGE_HEADER_VISIBLE:
      const { status, type } = state.visible

      return {
        ...state,
        visible: {
          type: action.payload,
          status: type === action.payload ? !status : true
        }
      }
    default:
      return state
  }
}